export interface FactoryProduct {
  id: string;
  name: string;
  samplePrice: number;
  bulkPrice: number;
  moq: number;
  image: string;
  category: string;
}

export interface Factory {
  id: string;
  name: string;
  city: string;
  established: number;
  employees: string;
  verified: boolean;
  dropshipping: boolean;
  warehouseCountries?: string[];
  rating: number;
  responseRate: string;
  onTimeDelivery: string;
  productCount: number;
  categories: string[];
  description: string;
  logo: string;
  coverImage: string;
  products: FactoryProduct[];
}

export const saudiFactories: Factory[] = [
  {
    id: "sf1",
    name: "Saudi Star Manufacturing Co.",
    city: "Riyadh",
    established: 2012,
    employees: "200–500",
    verified: true,
    dropshipping: false,
    rating: 4.8,
    responseRate: "95%",
    onTimeDelivery: "94%",
    productCount: 870,
    categories: ["Textiles", "Furniture", "Home Decor"],
    description: "Premium textile and furniture manufacturer serving global markets from Riyadh. Specializing in luxury Arabic home decor and handcrafted furniture.",
    logo: "https://public.readdy.ai/ai/img_res/55074db7e7350cbc8ba10288b41efc1b.jpg",
    coverImage: "https://readdy.ai/api/search-image?query=Saudi%20Arabia%20furniture%20textile%20factory%20Riyadh%20interior%20production%20workers%20professional%20bright%20clean%20modern&width=800&height=400&seq=sfc1&orientation=landscape",
    products: [
      {
        id: "sf1p1",
        name: "Handwoven Persian Carpet 3x5m",
        samplePrice: 850,
        bulkPrice: 320,
        moq: 1,
        category: "Home Decor",
        image: "https://readdy.ai/api/search-image?query=handwoven%20Persian%20carpet%20luxury%20traditional%20pattern%20gold%20red%20white%20background%20product%20photography%20premium&width=400&height=400&seq=sf1p1&orientation=squarish",
      },
      {
        id: "sf1p2",
        name: "Premium Arabic Thobe Fabric Roll",
        samplePrice: 25,
        bulkPrice: 8,
        moq: 100,
        category: "Textiles",
        image: "https://readdy.ai/api/search-image?query=premium%20white%20Arabic%20thobe%20fabric%20roll%20textile%20material%20clean%20white%20background%20product%20photography%20luxury&width=400&height=400&seq=sf1p2&orientation=squarish",
      },
      {
        id: "sf1p3",
        name: "Luxury Majlis Sofa Set",
        samplePrice: 2400,
        bulkPrice: 850,
        moq: 1,
        category: "Furniture",
        image: "https://readdy.ai/api/search-image?query=luxury%20Arabic%20majlis%20sofa%20set%20gold%20embroidery%20traditional%20Middle%20East%20furniture%20white%20background%20product%20photography&width=400&height=400&seq=sf1p3&orientation=squarish",
      },
    ],
  },
  {
    id: "sf2",
    name: "Aramco Industrial Supplies",
    city: "Dhahran",
    established: 2000,
    employees: "1000+",
    verified: true,
    dropshipping: false,
    rating: 4.9,
    responseRate: "97%",
    onTimeDelivery: "96%",
    productCount: 1560,
    categories: ["Industrial", "Oil & Gas", "Safety Equipment"],
    description: "World-class industrial supplier based in Dhahran. Providing oil & gas equipment, safety gear, and industrial tools to global energy companies.",
    logo: "https://readdy.ai/api/search-image?query=industrial%20oil%20gas%20company%20logo%20gold%20emblem%20white%20background%20Saudi%20Arabia%20corporate%20identity%20professional&width=80&height=80&seq=sfl2&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Saudi%20Arabia%20industrial%20factory%20Dhahran%20oil%20gas%20equipment%20production%20professional%20bright%20clean%20modern&width=800&height=400&seq=sfc2&orientation=landscape",
    products: [
      {
        id: "sf2p1",
        name: "Industrial Safety Equipment Set",
        samplePrice: 120,
        bulkPrice: 45,
        moq: 10,
        category: "Safety Equipment",
        image: "https://readdy.ai/api/search-image?query=industrial%20safety%20equipment%20set%20helmet%20gloves%20vest%20white%20background%20product%20photography%20professional%20clean&width=400&height=400&seq=sf2p1&orientation=squarish",
      },
      {
        id: "sf2p2",
        name: "Oil Pipeline Valve Assembly",
        samplePrice: 380,
        bulkPrice: 140,
        moq: 5,
        category: "Oil & Gas",
        image: "https://readdy.ai/api/search-image?query=oil%20pipeline%20valve%20assembly%20industrial%20equipment%20white%20background%20product%20photography%20professional%20metal&width=400&height=400&seq=sf2p2&orientation=squarish",
      },
      {
        id: "sf2p3",
        name: "Heavy Duty Industrial Gloves (12 pairs)",
        samplePrice: 35,
        bulkPrice: 12,
        moq: 100,
        category: "Safety Equipment",
        image: "https://readdy.ai/api/search-image?query=heavy%20duty%20industrial%20gloves%2012%20pairs%20safety%20equipment%20white%20background%20product%20photography%20professional&width=400&height=400&seq=sf2p3&orientation=squarish",
      },
    ],
  },
  {
    id: "sf3",
    name: "Al-Madinah Date Farms Export",
    city: "Madinah",
    established: 2010,
    employees: "100–200",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Saudi Arabia", "UAE", "UK", "USA", "Malaysia"],
    rating: 4.9,
    responseRate: "96%",
    onTimeDelivery: "95%",
    productCount: 280,
    categories: ["Food", "Agriculture", "Gift Sets"],
    description: "Premium Medjool and Ajwa date exporter from Madinah. Supplying luxury date gift boxes to global retailers and dropshippers with halal certification.",
    logo: "https://readdy.ai/api/search-image?query=date%20farm%20export%20company%20logo%20gold%20palm%20tree%20emblem%20white%20background%20Saudi%20Arabia%20Madinah%20corporate%20identity&width=80&height=80&seq=sfl3&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Saudi%20Arabia%20date%20farm%20Madinah%20palm%20trees%20harvest%20production%20packaging%20professional%20bright%20clean&width=800&height=400&seq=sfc3&orientation=landscape",
    products: [
      {
        id: "sf3p1",
        name: "Premium Medjool Dates Gift Box 1kg",
        samplePrice: 65,
        bulkPrice: 22,
        moq: 20,
        category: "Food",
        image: "https://readdy.ai/api/search-image?query=premium%20Medjool%20dates%20gift%20box%201kg%20luxury%20gold%20packaging%20Saudi%20Arabia%20white%20background%20product%20photography&width=400&height=400&seq=sf3p1&orientation=squarish",
      },
      {
        id: "sf3p2",
        name: "Ajwa Dates Premium Box 500g",
        samplePrice: 45,
        bulkPrice: 18,
        moq: 30,
        category: "Food",
        image: "https://readdy.ai/api/search-image?query=Ajwa%20dates%20premium%20box%20500g%20luxury%20packaging%20gold%20Arabic%20design%20white%20background%20product%20photography&width=400&height=400&seq=sf3p2&orientation=squarish",
      },
      {
        id: "sf3p3",
        name: "Mixed Dates Corporate Gift Set",
        samplePrice: 85,
        bulkPrice: 35,
        moq: 15,
        category: "Gift Sets",
        image: "https://readdy.ai/api/search-image?query=mixed%20dates%20corporate%20gift%20set%20luxury%20gold%20box%20Arabic%20design%20white%20background%20product%20photography%20premium&width=400&height=400&seq=sf3p3&orientation=squarish",
      },
    ],
  },
  {
    id: "sf4",
    name: "Jeddah Garment Factory",
    city: "Jeddah",
    established: 2018,
    employees: "50–100",
    verified: false,
    dropshipping: true,
    warehouseCountries: ["Saudi Arabia", "UAE", "Turkey"],
    rating: 4.3,
    responseRate: "85%",
    onTimeDelivery: "88%",
    productCount: 340,
    categories: ["Clothing", "Sportswear", "Uniforms"],
    description: "Affordable garment manufacturer in Jeddah offering custom uniforms, sportswear, and branded clothing with dropshipping support.",
    logo: "https://readdy.ai/api/search-image?query=garment%20factory%20logo%20gold%20needle%20thread%20emblem%20white%20background%20Saudi%20Arabia%20fashion%20manufacturing%20corporate&width=80&height=80&seq=sfl4&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Jeddah%20Saudi%20Arabia%20garment%20factory%20sewing%20machines%20workers%20clothing%20production%20professional%20bright%20interior&width=800&height=400&seq=sfc4&orientation=landscape",
    products: [
      {
        id: "sf4p1",
        name: "Custom Sports Uniform Set",
        samplePrice: 35,
        bulkPrice: 12,
        moq: 20,
        category: "Sportswear",
        image: "https://readdy.ai/api/search-image?query=custom%20sports%20uniform%20set%20jersey%20shorts%20professional%20athletic%20wear%20white%20background%20product%20photography%20clean&width=400&height=400&seq=sf4p1&orientation=squarish",
      },
      {
        id: "sf4p2",
        name: "Corporate Uniform Shirt (Custom Logo)",
        samplePrice: 22,
        bulkPrice: 8,
        moq: 50,
        category: "Uniforms",
        image: "https://readdy.ai/api/search-image?query=corporate%20uniform%20shirt%20custom%20logo%20professional%20white%20background%20product%20photography%20clean%20business%20workwear&width=400&height=400&seq=sf4p2&orientation=squarish",
      },
      {
        id: "sf4p3",
        name: "Traditional Saudi Thobe (White)",
        samplePrice: 45,
        bulkPrice: 18,
        moq: 30,
        category: "Clothing",
        image: "https://readdy.ai/api/search-image?query=traditional%20Saudi%20thobe%20white%20elegant%20garment%20white%20background%20product%20photography%20premium%20clothing%20Middle%20East&width=400&height=400&seq=sf4p3&orientation=squarish",
      },
    ],
  },
  {
    id: "sf5",
    name: "Riyadh Furniture Makers",
    city: "Riyadh",
    established: 2007,
    employees: "200–500",
    verified: true,
    dropshipping: false,
    rating: 4.7,
    responseRate: "92%",
    onTimeDelivery: "91%",
    productCount: 620,
    categories: ["Furniture", "Interior Design", "Office"],
    description: "Premium furniture manufacturer in Riyadh crafting luxury Arabic and modern office furniture for hotels, offices, and residential projects worldwide.",
    logo: "https://readdy.ai/api/search-image?query=furniture%20company%20logo%20gold%20chair%20emblem%20white%20background%20Riyadh%20Saudi%20Arabia%20corporate%20identity%20elegant&width=80&height=80&seq=sfl5&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Riyadh%20Saudi%20Arabia%20furniture%20factory%20workshop%20craftsmen%20wood%20production%20professional%20bright%20interior%20modern&width=800&height=400&seq=sfc5&orientation=landscape",
    products: [
      {
        id: "sf5p1",
        name: "Executive Office Desk Set",
        samplePrice: 1200,
        bulkPrice: 480,
        moq: 2,
        category: "Office",
        image: "https://readdy.ai/api/search-image?query=executive%20office%20desk%20set%20luxury%20wood%20modern%20design%20white%20background%20product%20photography%20professional%20furniture&width=400&height=400&seq=sf5p1&orientation=squarish",
      },
      {
        id: "sf5p2",
        name: "Arabic Majlis Cushion Set (12pcs)",
        samplePrice: 75,
        bulkPrice: 28,
        moq: 20,
        category: "Interior Design",
        image: "https://readdy.ai/api/search-image?query=luxury%20Arabic%20majlis%20cushion%20set%20gold%20embroidery%20traditional%20Middle%20East%20home%20decor%20white%20background%20product&width=400&height=400&seq=sf5p2&orientation=squarish",
      },
      {
        id: "sf5p3",
        name: "Hotel Lobby Sofa (3-Seater)",
        samplePrice: 1800,
        bulkPrice: 750,
        moq: 2,
        category: "Furniture",
        image: "https://readdy.ai/api/search-image?query=hotel%20lobby%20sofa%203%20seater%20luxury%20elegant%20modern%20design%20white%20background%20product%20photography%20professional%20furniture&width=400&height=400&seq=sf5p3&orientation=squarish",
      },
    ],
  },
  {
    id: "sf6",
    name: "Saudi Petrochemical Products",
    city: "Jubail",
    established: 2003,
    employees: "500–1000",
    verified: true,
    dropshipping: false,
    rating: 4.6,
    responseRate: "90%",
    onTimeDelivery: "93%",
    productCount: 430,
    categories: ["Chemicals", "Plastics", "Packaging"],
    description: "Industrial chemical and plastic manufacturer in Jubail Industrial City. Supplying food-grade plastics, industrial chemicals, and packaging materials globally.",
    logo: "https://readdy.ai/api/search-image?query=petrochemical%20company%20logo%20gold%20molecule%20emblem%20white%20background%20Jubail%20Saudi%20Arabia%20corporate%20identity%20professional&width=80&height=80&seq=sfl6&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Jubail%20Saudi%20Arabia%20petrochemical%20factory%20industrial%20plant%20production%20professional%20bright%20clean%20modern%20aerial&width=800&height=400&seq=sfc6&orientation=landscape",
    products: [
      {
        id: "sf6p1",
        name: "Food-Grade HDPE Containers (50pcs)",
        samplePrice: 45,
        bulkPrice: 12,
        moq: 500,
        category: "Packaging",
        image: "https://readdy.ai/api/search-image?query=food%20grade%20HDPE%20containers%2050pcs%20plastic%20white%20background%20product%20photography%20professional%20clean%20minimal%20packaging&width=400&height=400&seq=sf6p1&orientation=squarish",
      },
      {
        id: "sf6p2",
        name: "Industrial Cleaning Chemical 20L",
        samplePrice: 55,
        bulkPrice: 22,
        moq: 50,
        category: "Chemicals",
        image: "https://readdy.ai/api/search-image?query=industrial%20cleaning%20chemical%2020L%20drum%20white%20background%20product%20photography%20professional%20clean%20industrial&width=400&height=400&seq=sf6p2&orientation=squarish",
      },
      {
        id: "sf6p3",
        name: "PP Woven Bags (100pcs)",
        samplePrice: 28,
        bulkPrice: 8,
        moq: 1000,
        category: "Packaging",
        image: "https://readdy.ai/api/search-image?query=PP%20woven%20bags%20100pcs%20industrial%20packaging%20white%20background%20product%20photography%20professional%20clean%20bulk&width=400&height=400&seq=sf6p3&orientation=squarish",
      },
    ],
  },
];
